import React from 'react';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetStaticProps } from 'next';
import { useTranslations } from 'next-intl';

import { ExitFeedBackModal, getFeatures, getPlanPrice, Main, proConst, useExitFeedback } from 'modules/pro';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();

  useExitFeedback();

  return (
    <>
      <NextHead title={t('meta.pro.title')} description={t('meta.pro.description')} />
      <Main />
      <ExitFeedBackModal />
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  await Promise.allSettled([
    queryClient.prefetchQuery({
      queryKey: [proConst.queryKeys.PRO_FEATURES],
      queryFn: getFeatures
    }),
    queryClient.prefetchQuery({
      queryKey: [proConst.queryKeys.PLAN_PRICE],
      queryFn: getPlanPrice
    })
  ]);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      messages: (await import(`../../messages/${locale}.json`)).default
    }
  };
};
